(function ($) {
  $(document).ready(function () {
    const modals = document.querySelectorAll('[data-modal]');
    const modalOpeners = document.querySelectorAll('[data-modal-open]');
    const modalClosers = document.querySelectorAll('[data-modal-close]');

    modalOpeners.forEach(function (opener) {
      opener.addEventListener('click', function () {
        modals.forEach(function (modal) {
          modal.dataset.visible = 'false';
        });

        const targetId = this.dataset.modalOpen;
        const target = document.querySelector(`[data-modal="${targetId}"]`);
        if (target) {
          target.dataset.visible = 'true';
        }
      });
    });

    modalClosers.forEach(function (closer) {
      closer.addEventListener('click', function () {
        const targetId = this.dataset.modalClose;
        const target = document.querySelector(`[data-modal="${targetId}"]`);
        if (target) {
          target.dataset.visible = 'false';
        }
      });
    });
  });
}(jQuery));
